import { createCookie, getCookie } from "./lib/cookie";
import {
    userAgentHelper,
    referrerHelper,
    currentPageHelper,
    pageViewHelper,
} from "./lib/helpers";

function getUserAgentData() {
    const userAgent = window.navigator.userAgent;
    return userAgentHelper(userAgent);
}

function getReferrerData() {
    const referrer = document?.referrer;
    return referrerHelper(referrer);
}

function getPageData() {
    const url = window.location.href;
    return currentPageHelper(url);
}

function getPageViewData() {
    return pageViewHelper(document.title, window.location);
}

function getCookieData(name, domain) {
    const cookie = getCookie(name);
    if (!cookie) {
        return createCookie(name, domain);
    } else {
        return cookie;
    }
}

export type CollectDataOpts = {
    ua?: boolean;
    referrer?: boolean;
    page?: boolean;
    cookie?: boolean;
    cookieName?: string;
    cookieDomain?: string;
};

export function collectData({
    ua = true,
    referrer = true,
    page = true,
    cookie = true,
    cookieName = "watchtower",
    cookieDomain = "caresource.com",
}: CollectDataOpts = {}) {
    // Get or Set Cookie
    const cookieData = cookie && getCookieData(cookieName, cookieDomain);

    // Build out requested props
    const { deviceProperties: uaDeviceProperties, ...uaData } =
        getUserAgentData();

    const data = {
        ...(ua ? uaData : {}),
        ...(referrer ? getReferrerData() : {}),
        ...(page ? getPageData() : {}),
        ...(ua ? { deviceProperties: uaDeviceProperties } : {}), // custom UA props
    };

    return {
        data,
        ...(page && { pageView: getPageViewData() }),
        ...(cookieData && { anonId: cookieData as string }),
    };
}
